export default "__VITE_ASSET__05919ef8__"